import { loadGoogleAnalytics } from './load-google-analytics'
/**
 * Records impression event for Google Analytics.
 * @param {String} pathname path of the page to track
 */
export function recordGaImpression(pathname) {
  loadGoogleAnalytics(pathname)
}
